var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import { breadcrumbItemClickHandler } from './breadcrumb-item-click-handler';
import { Icon } from '../../icon/src';
var preventDefault = function (e) { return e.preventDefault(); };
// uid solves the issue with magically disappearing the arrow icons
// described here https://issues.amazon.com/issues/AWSUI-6738
var uid = 0;
export var Item = function (_a) {
    var href = _a.href, text = _a.text, ariaCurrent = _a.ariaCurrent, disableInteraction = _a.disableInteraction, onClick = _a.onClick, hideIcon = _a.hideIcon;
    var linkAttributes = {
        href: href,
        className: 'awsui-breadcrumb-link',
        'aria-current': ariaCurrent,
        'aria-disabled': disableInteraction ? 'true' : undefined,
        onclick: disableInteraction ? preventDefault : onClick
    };
    return (AwsUi.__createElement("div", { className: "awsui-breadcrumb" },
        AwsUi.__createElement("a", __assign({}, linkAttributes),
            AwsUi.__createElement("span", { className: "awsui-breadcrumb-link-text" }, text)),
        !hideIcon ? AwsUi.__createElement(Icon, { key: uid++, name: "angle-right", variant: "disabled" }) : null));
};
export var BreadcrumbItem = AwsUi.__addComponent('awsui-breadcrumb-item', {
    releaseStatus: 'deprecated',
    properties: {
        // Text displayed in the breadcrumb item.
        text: {
            type: 'string'
        },
        // URL for the link within the breadcrumb item. You should specify the link
        // even if you have the click handler for a breadcrumb item. This will ensure that
        // valid markup is generated.
        href: {
            type: 'string'
        },
        // Adds `aria-current` attribute on the element. Set this to `page` for the
        // last breadcrumb item in the group. This will make component to be understood
        // better by screen readers
        ariaCurrent: {
            type: 'string'
        }
    },
    events: {
        // Fired when the user clicks on the breadcrumb item.
        //
        // **AngularJS:** `ng-click` works incorrectly, you need to use `click` attribute
        click: {
            bubbles: true,
            cancelable: true,
            detailType: 'BreadcrumbGroup.ClickDetail'
        },
        // Fired when the user clicks on the breadcrumb item with the left mouse button and
        // without modifier keys pressed (CTRL, ALT, SHIFT, META).
        follow: {
            bubbles: true,
            cancelable: true,
            detailType: 'BreadcrumbGroup.ClickDetail'
        }
    },
    render: function () {
        var _this = this;
        var props = {
            text: this.text,
            href: this.href || '#',
            ariaCurrent: this.ariaCurrent,
            onClick: function (event) {
                breadcrumbItemClickHandler(_this, {
                    text: _this.text,
                    href: _this.href
                }, event);
            }
        };
        return AwsUi.__createElement(Item, __assign({}, props));
    }
});
//# sourceMappingURL=breadcrumb-item.js.map